/*
 * Copyright (c) 2025 Sila Artificial Intelligence Research LLC
 * A DA Holding Ltd Company
 * All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 * This software and its documentation are proprietary to Sila Artificial
 * Intelligence Research LLC. Unauthorized copying, distribution, or use
 * of this software is strictly prohibited.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

/**
 * Chart Colors and Constants
 * Centralized color palette for all chart components
 */

export const CHART_COLORS = {
  // Primary brand color - Deep Indigo (matching trends-2)
  primary: '#4F46E5',

  // Secondary colors
  secondary: '#22D3EE', // Cyan (for contrast)
  tertiary: '#A855F7', // Soft Purple
  accent: '#F59E0B', // Amber

  // Semantic colors
  positive: '#10B981', // Green - for positive metrics
  negative: '#EF4444', // Red - for negative metrics
  warning: '#F59E0B', // Amber - for warning/neutral
  info: '#22D3EE', // Cyan - for informational

  // Chart palette (for multi-series charts) - Premium palette
  chartColors: [
    '#4F46E5', // Deep Indigo
    '#22D3EE', // Cyan
    '#A855F7', // Purple
    '#10B981', // Green
    '#F59E0B', // Amber
    '#EC4899', // Pink
    '#14B8A6', // Teal
    '#F97316', // Orange
  ],

  // Gradient definitions - Premium gradients
  gradients: {
    primary: 'linear-gradient(135deg, #4F46E5 0%, #A855F7 100%)',
    secondary: 'linear-gradient(135deg, #22D3EE 0%, #06B6D4 100%)',
    danger: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
    warning: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
    success: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  }
} as const;

/**
 * Z-Index Constants for Chart Elements
 */
export const CHART_Z_INDEX = {
  tooltip: 1000,
  legend: 100,
  grid: 1,
  axis: 10,
  series: 50,
} as const;

/**
 * Chart Animation Durations (in ms)
 */
export const CHART_ANIMATION = {
  fast: 200,
  normal: 500,
  slow: 1000,
} as const;

/**
 * Default Chart Dimensions
 */
export const CHART_DIMENSIONS = {
  defaultHeight: 300,
  gaugeHeight: 200,
  smallHeight: 150,
  largeHeight: 400,
} as const;
